const cents = (value) => {
    const match = /^(-?)(\d+)(?:\.(\d{1,2}))?$/.exec(value);
    if (!match)
        throw new Error('INVALID_CASH_COMPARISON_AMOUNT');
    const n = BigInt(match[2]) * 100n + BigInt((match[3] ?? '').padEnd(2, '0'));
    return match[1] ? -n : n;
};
const money = (value) => {
    const n = value < 0n ? -value : value;
    return `${value < 0n ? '-' : ''}${n / 100n}.${String(n % 100n).padStart(2, '0')}`;
};
/** A single snapshot, final admitted routes only. No historical reconstruction or writes. */
export function cashComparison(snapshot) {
    const routes = snapshot.dailySettlement?.routes ?? [];
    return snapshot.bags.map((bag) => {
        const net = routes.reduce((n, route) => {
            const amount = cents(route.amount);
            return (n +
                (route.toLocationId === bag.id ? amount : 0n) -
                (route.fromLocationId === bag.id ? amount : 0n));
        }, 0n);
        const projected = cents(bag.amount) + net;
        const member = bag.kind === 'ZIPA_DRAWER' ? cents(snapshot.memberZipaBalance) : null;
        return {
            ...bag,
            pending: snapshot.dailySettlement ? money(net) : null,
            projected: snapshot.dailySettlement ? money(projected) : null,
            bookedDifference: member === null ? null : money(cents(bag.amount) - member),
            projectedDifference: member === null || !snapshot.dailySettlement ? null : money(projected - member),
        };
    });
}
//# sourceMappingURL=cash-comparison.js.map